// extracted by mini-css-extract-plugin
export default {"container":"VideoPage_container__Mk6Bp","cardTitle":"VideoPage_cardTitle__h8eWd","iframeContainer":"VideoPage_iframeContainer__6bYiQ","title":"VideoPage_title__Bu9lZ"};